import {ConfigProvider, Image, Space} from 'antd';
import {ReactElement} from 'react';

import {classNames} from '../../../../../../../util/css';

import * as styles from './preview-group.scss';

type PropsType = {
    images?: Array<{src: string | null; alt: string | null}>;
    imageClassName?: string;
};

export function PreviewGroup(props: PropsType): ReactElement {
    const {images, imageClassName} = props;

    return (
        <ConfigProvider
            locale={{
                locale: '',
                Image: {preview: ''},
            }}
        >
            <Image.PreviewGroup>
                <Space className={styles.ImageGallery_list} direction="horizontal">
                    {images?.map((image) => (
                        <Image
                            // eslint-disable-next-line no-undefined
                            alt={image.alt ?? undefined}
                            className={classNames(styles.ImageGallery_image, imageClassName)}
                            key={image.src}
                            preview={{maskClassName: styles.ImageGallery_mask}}
                            // eslint-disable-next-line no-undefined
                            src={image.src ?? undefined}
                            wrapperClassName={styles.ImageGallery_wrapper}
                        />
                    ))}
                </Space>
            </Image.PreviewGroup>
        </ConfigProvider>
    );
}
